import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';
import type { ComicItem } from '@/mocks/comics';

function FeaturedCard({ comic, variant }: { comic: ComicItem; variant: 'large' | 'small-top' | 'small-bottom' }) {
  if (variant === 'large') {
    return (
      <Link
        to={`/article/${comic.id}`}
        className="group relative rounded-2xl overflow-hidden h-full min-h-[400px] md:min-h-[480px] cursor-pointer block"
      >
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
          <span className="inline-block px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500 text-background-50 mb-2">
            {comic.status}
          </span>
          <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 mb-1">
            {comic.title}
          </h3>
          <p className="text-sm text-background-50/70 line-clamp-2">{comic.description}</p>
          <div className="flex items-center gap-3 mt-2">
            <span className="flex items-center gap-1 text-xs text-secondary-300">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-star-fill text-xs"></i>
              </span>
              {comic.rating}
            </span>
            <span className="text-xs text-background-50/50">{comic.author}</span>
            <span className="text-xs text-background-50/50">{comic.views.toLocaleString()} 阅读</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group relative rounded-2xl overflow-hidden h-[190px] md:h-[230px] cursor-pointer block"
    >
      <img
        src={comic.cover}
        alt={comic.title}
        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/5 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
        <h3 className="text-sm md:text-base font-heading font-bold text-background-50 mb-0.5">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2">
          <span className="flex items-center gap-1 text-xs text-secondary-300">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-xs"></i>
            </span>
            {comic.rating}
          </span>
          <span className="text-xs text-background-50/50">{comic.latestChapter}</span>
        </div>
      </div>
    </Link>
  );
}

export default function FeaturedGrid() {
  const mainComic = featuredComics[0];
  const smallComics = featuredComics.slice(1, 3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            热门<span className="text-accent-500">漫画</span>推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            精选高分韩漫，每日更新，总有一部让你爱不释手
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
          <div className="lg:w-1/2">
            <FeaturedCard comic={mainComic} variant="large" />
          </div>
          <div className="lg:w-1/2 flex flex-col gap-4 md:gap-5">
            {smallComics.map((comic, idx) => (
              <FeaturedCard
                key={comic.id}
                comic={comic}
                variant={idx === 0 ? 'small-top' : 'small-bottom'}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}